export default "__VITE_ASSET__BL4kK_kj__"